/**
 * Steps are grouped in IAHelpStepsGroup
 */

class IAHelpStepsGroup {
  constructor(title, steps = [], onNext = null) {
    this.title = title;
    this.steps = steps;
    this.onNext = onNext;
  }
}

export default IAHelpStepsGroup;
